import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AmazonService } from "../../../services/amazon.service";

@Component({
    selector: 'amazon-instructions',
    templateUrl: 'amazon-instructions.component.html',
    moduleId: module.id.toString(),
})

export class AmazonInstructionsComponent {

    constructor(public amazonService: AmazonService, public router: Router) {

    }

    public showMore: boolean = false;

    public navigateUser() {
        if (!this.amazonService.prevUrl){
            this.router.navigate(['amazon/info/dashboard']);
        } else {
            this.router.navigate([this.amazonService.prevUrl]);
        }
    }

    public showOtherInstructions(){
        this.showMore = true;
        const el = document.querySelector("#amazonInfo");

        if (el) {
            el.scrollTop = 0
        }

    }

}


// WEBPACK FOOTER //
// ./app/components/amazon/instructions/amazon-instructions.component.ts